import capitalize from 'lodash-es/capitalize'
import React from 'react'

import { Button, ModalBox } from '@fourthwall/components'

import { useShopTime } from '../../../../Timezone/providers/ShopTimeProvider'
import { DATE_FORMAT } from './consts'
import type { Props } from './types'

export const StatusConfirmationModal = ({
  newStatus = 'PUBLIC',
  startDate,
  endDate,
  onConfirm,
  close,
}: Props) => {
  const { toShopTime } = useShopTime()
  const renderNewStatus = () => capitalize(newStatus)

  const formatDate = (date: Date) => toShopTime(date).format(DATE_FORMAT)

  const renderStartDate = () => {
    return startDate ? <> from {formatDate(startDate)}</> : null
  }

  const renderEndDate = () => {
    return endDate ? <> to {formatDate(endDate)}</> : null
  }

  const handleConfirm = (withStatusUpdate: boolean) => {
    close()
    onConfirm(withStatusUpdate)
  }

  return (
    <ModalBox
      title={
        <>
          Do you want to change the status of products in this collection to {renderNewStatus()}
          {renderStartDate()}
          {renderEndDate()}?
        </>
      }
      buttons={[
        <Button label="Cancel" onClick={close} />,
        <Button
          label="No, don't change"
          appearance="primary"
          onClick={() => handleConfirm(false)}
        />,
        <Button label="Yes, change" appearance="primary" onClick={() => handleConfirm(true)} />,
      ]}
      onClose={close}
    >
      <>
        Changing the status on a collection optionally updates the status of all products added to
        this collection. Do you want to change the status of all products in this collection to{' '}
        {renderNewStatus()}
        {renderStartDate()}
        {renderEndDate()}?
      </>
    </ModalBox>
  )
}
